import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { plural } from '../../../../../shared/helpers';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import { Icon, regularIcons } from '../../../generic';

import sharedStyles from '../IssueDetails.module.less';
import styles from './IssueDetailsStatus.module.less';

/**
 * Display the issue details status in the global scope.
 */
const GlobalScopeIssueDetailsStatus: VoidFunctionComponent = () => {
  const activeCount = useSelector(IssuesV2Store.selectors.getActiveIssueCount);
  const ignoredCount = useSelector(IssuesV2Store.selectors.getIgnoredIssueCount);
  const ticketedCount = useSelector(IssuesV2Store.selectors.getTicketedIssueCount);

  return (
    <div className={styles.globalIssueDetailsStatus}>
      {activeCount > 0 && (
        <span>
          <span className={`${sharedStyles.icon} ${sharedStyles.activeIcon}`}>
            <Icon icon={regularIcons.exclamationCircleRegular} />
          </span>
          <span className="bold">Active</span> in {activeCount} {plural(activeCount, 'project')}
        </span>
      )}
      {ignoredCount > 0 && (
        <span>
          <span className={`${sharedStyles.icon} ${sharedStyles.ignoredIcon}`}>
            <Icon icon={regularIcons.eyeSlashRegular} />
          </span>
          <span className="bold">Ignored</span> in {ignoredCount} {plural(ignoredCount, 'project')}
        </span>
      )}
      {ticketedCount > 0 && (
        <span>
          <span className={`${sharedStyles.icon} ${sharedStyles.ticketedIcon}`}>
            <Icon icon={regularIcons.ticket} />
          </span>
          <span className="bold">Ticketed</span> in {ticketedCount} {plural(ticketedCount, 'project')}
        </span>
      )}
    </div>
  );
};

export default GlobalScopeIssueDetailsStatus;
